import http from '../../utils/http'

// Endpoints
const usersEndpoint = '/users'

export const updateData = ({ user, data }) => {
  return http
    .put(`${usersEndpoint}/${user.id}`, data)
    .then(res => res.data)
}

export const updatePhoto = ({ user, url }) => {
  return updateData({ user, data: { photo_url: url } })
}

export const updateEmail = ({ user, email }) => {
  return updateData({ user, data: { email } })
}

export const updatePassword = ({ user, password }) => {
  return updateData({ user, data: { password } })
}
